import React from "react"
import {
  Box,
  Flex,
  Text,
  Heading,
  useColorModeValue,
  Container,
  Stat,
  Accordion
} from "@chakra-ui/react"
import Image from "next/image"
import AccordionMenu from "../../components/accordion/AccordionMenu"
import SummaryMatricImg from "../../public/img/business-metrics-health.png"
import TopSellingImg from "../../public/img/features-image2.png"
import TechStartup from "../../public/img/tech-startup.png"
import { sellerReportFrequentlyAskedQuestions } from "../../data/SellerReportFrequentlyAskedQuestions"
import styles from "../../styles/seller-intelligence.module.css"
import Meta from "../../components/meta/Meta"
import { CheckIcon } from "@chakra-ui/icons"

export default function SellerIntelligenceReport() {
  const textColor = useColorModeValue("gray.500", "white")

  return (
    <>
      <Meta
        pageName={"Seller Intelligence Report To Outshine The Competition - TrackSellers"}
        description={"Want to outperform your competitor? Our Seller Intelligence Report provides all info of Amazon sellers like top selling products, reviews & more."}
        hrefLink={"https://www.tracksellers.com/seller-intelligence-report"}
      />
      <Box className={styles.ReportMainBox}>
        <Container maxW="container.xl">
          <Box pb="1rem">
            <Box className={styles.ReportSubBox}>
              <Heading as={"h1"} mb="18px" className={styles.ReportHead} >
                Amazon Sellers Intelligence Report For In-Depth Amazon Seller Analysis
              </Heading>
              <Text fontSize={{ base: "1.2rem", md: "1.2rem", lg: "1.5rem" }} maxW={{ base: "100%", md: "100%", lg: "70%" }} className={styles.SellerIntelligneceSubHead}>
                Gain comprehensive insights into any Amazon seller&apos;s business, metrics, and product listings to make data-driven decisions and stay ahead of the competition.
              </Text>
            </Box>
          </Box>
          <Box pt="0rem">
            {/* <Heading className={styles.ReportFeatures}>
              Features
            </Heading> */}
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "0rem", md: "1rem", lg: "1rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                direction={{ base: "column-reverse", sm: "column-reverse", md: "column-reverse", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={SummaryMatricImg}
                    alt="SummaryMatric"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pb={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Stat me="auto">
                    <Heading color="#243e63" fontSize={{ base: "2rem", md: "2rem", lg: "2rem" }}
                      mb={{ base: "5px", md: "10px", lg: "10px" }}
                    >
                      Key Business Metrics of Amazon Sellers Intelligence and Amazon Seller Overview
                    </Heading>
                    {/* <Flex>
                      <Text className={styles.CardStatNumber}>
                        Relevant summary metrics include:
                      </Text>
                    </Flex> */}
                    <Box mt="1.5rem">
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Obtain a snapshot of essential seller metrics, including revenue, order estimates, seller type, rank, reviews, and ratings.
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Quickly identify potential growth areas or collaboration opportunities with seller business entity and location information.
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Understand a seller&apos;s primary focus through their category listings and identify market trends.
                        </Text>
                      </Flex>
                    </Box>
                  </Stat>
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                direction={{ base: "column", md: "column", lg: "row" }}>
                <Box flex="1"
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pb={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Heading color="#243e63" fontSize={{ base: "2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Uncover Amazon Brands And Amazon Seller Product Categories
                  </Heading>
                  <Box mt="1.5rem">
                    <Flex className={styles.CardPoints}>
                      <CheckIcon
                        color="orange.300"
                        className={styles.CardPointIcons}
                      />
                      <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                        Analyze the brands a seller lists on Amazon to identify their business model and potential partnerships or threats.
                      </Text>
                    </Flex>
                    <Flex className={styles.CardPoints}>
                      <CheckIcon
                        color="orange.300"
                        className={styles.CardPointIcons}
                      />
                      <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                        Examine Buybox share at both category and brand levels to optimize your product portfolio and competitiveness.
                      </Text>
                    </Flex>
                    <Flex className={styles.CardPoints}>
                      <CheckIcon
                        color="orange.300"
                        className={styles.CardPointIcons}
                      />
                      <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                        Gain insights into a seller&apos;s product category mix to identify niche markets and develop targeted strategies.
                      </Text>
                    </Flex>
                  </Box>
                </Box>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={TopSellingImg}
                    alt="TopSellingImg"
                  />
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                direction={{ base: "column-reverse", md: "column-reverse", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={TechStartup}
                    alt="TechStartup"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pb={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}
                >
                  <Heading color="#243e63" fontSize={{ base: "2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Dive Deeper into Amazon Seller History and Product Listings
                  </Heading>
                  <Box mt="1.5rem">
                    <Flex className={styles.CardPoints}>
                      <CheckIcon
                        color="orange.300"
                        className={styles.CardPointIcons}
                      />
                      <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                        Review a three-year history of a seller&apos;s reviews, offering insights into order volumes, sales performance, and seasonality.
                      </Text>
                    </Flex>
                    <Flex className={styles.CardPoints}>
                      <CheckIcon
                        color="orange.300"
                        className={styles.CardPointIcons}
                      />
                      <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                        Access up to 5,000 product listings with detailed attributes like barcode, title, price, Amazon fees, category, and sales rank.
                      </Text>
                    </Flex>
                    <Flex className={styles.CardPoints}>
                      <CheckIcon
                        color="orange.300"
                        className={styles.CardPointIcons}
                      />
                      <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                        Analyze your competition&apos;s product offerings, pricing strategies, and market positioning to exploit potential market gaps.
                      </Text>
                    </Flex>
                  </Box>
                </Box>
              </Flex>
            </Box>
            {/* <Box>
              <Flex
                pb={{ base: "1rem", md: "0rem", lg: "0rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                direction={{ base: "column", md: "column", lg: "row" }}
              >
                <Box flex="1" pb={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Heading color="#243e63" fontSize={{ base: "2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Top Selling Products
                  </Heading>
                  <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize="1.2rem" fontWeight="400">
                    {"Seller's top-selling products page includes product attributes such as title, sales rank, Buybox price, competing offer count, FBA fees, brand, category etc."}
                  </Text>
                </Box>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={TopSellingImg}
                    alt="SummaryMatric"
                  />
                </Box>
              </Flex>
            </Box> */}
          </Box>
        </Container>
        <Box mt="2rem" mb="2rem" textAlign="center" >
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Maximize Your Competitive Advantage With The Seller Intelligence Report
          </Text>
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" mb="1.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Don&apos;t miss the opportunity to gain comprehensive insights into any Amazon seller&apos;s business, metrics, and product listings. Make data-driven decisions and stay ahead of the competition with the Seller Intelligence Report.
          </Text>
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" mb="1.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            To get started, simply search for a seller&apos;s name and click on the &quot;Seller Intelligence Report&quot; to purchase the report securely.
          </Text>
        </Box>
        <Box pt="2rem" pb="2rem" background="#fff">
          <Box>
            <Box className={styles.ReportFaqBox}>
              <Heading className={styles.ReportFeatures}>
                Frequently Asked Questions
              </Heading>
              <Accordion w="100%" maxWidth="800px" allowToggle defaultIndex={[0]} allowMultiple={false}>
                {
                  sellerReportFrequentlyAskedQuestions?.map((ques, index) =>
                    (<AccordionMenu {...ques} key={index} />))
                }
              </Accordion>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}